// extracted by mini-css-extract-plugin
export default {"link":"leaseManagement_link__mkYWF","single_line":"leaseManagement_single_line__kRSzf","sdetail_row":"leaseManagement_sdetail_row__QUkU1"};